// extracted by mini-css-extract-plugin
export var centered = "_u-6";
export var flexible = "_u-5";
export var footer = "_u-k";
export var footerBorder = "_u-l";
export var header = "_u-c";
export var headerBorder = "_u-d";
export var headerDefault = "_u-g";
export var headerMedium = "_u-h";
export var headerPadding = "_u-e";
export var iconAndTitle = "_u-f";
export var large = "_u-4";
export var largePadding = "_u-a";
export var medium = "_u-3";
export var mediumPadding = "_u-9";
export var modal = "_u-0";
export var modalContainer = "_u-b";
export var noPadding = "_u-7";
export var skinny = "_u-1";
export var small = "_u-2";
export var smallPadding = "_u-8";
export var subtitle = "_u-j";
export var title = "_u-i";